import { render, staticRenderFns } from "./TestatorsList.vue?vue&type=template&id=5cafb1d8"
import script from "./TestatorsList.vue?vue&type=script&lang=js"
export * from "./TestatorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports